import request from "../../request.js"
import URL from "../../url/nav/index.js"
import CONFIG from "@/js/utils/config";
class Nav{
    //獲取導航欄數據
    static columnData(){
        return request.get({
            url: URL.COLUMN_URL,
            config: {
                // headers:{
                //     "Content-Type":"application/json"
                // },
                // baseURL:CONFIG.BASE_HTTP_URL,
                common: {
                    useToken: false,
                }
            }
        })
    }
    static getData(){
        let data = {
            url: URL.DATA,
            config: {
                // headers:{
                //     "Content-Type":"application/json"
                // },
                // baseURL:CONFIG.BASE_HTTP_URL,
                common: {
                    useToken: false,
                }
            }
        }
        return request.get(data)
    }
    //V5獲取導航欄數據
    static columnDataV5(){
        return request.get({
            url: URL.COLUMN_URL_V5,
            config: {
                // headers:{
                //     "Content-Type":"application/json"
                // },
                // baseURL:CONFIG.BASE_HTTP_URL,
                common: {
                    useToken: false,
                }
            }
        })
    }
    static getDataV5(){
        let data = {
            url: URL.DATA_V5,
            config: {
                // headers:{
                //     "Content-Type":"application/json"
                // },
                // baseURL:CONFIG.BASE_HTTP_URL,
                common: {
                    useToken: false,
                }
            }
        }
        return request.get(data)
    }
}

export default Nav